import { BsFillCheckCircleFill } from "components/atoms/Icon/bs/BsFillCheckCircleFill";

import styles from "./Index.module.scss";

const StepBar = ({ step, subStep, data }) => {
  const width = 100 / data?.length;

  return (
    <>
      <div className={"hidden items-start lg:flex"}>
        {data?.map((item, index) => {
          return (
            <div
              key={index}
              className="col flex last:col-auto last:block last:w-[112px]"
            >
              <div
                className={"col flex max-w-[112px] flex-col items-center   "}
              >
                {step - 1 === index ? (
                  <div className="h-8 w-8  rounded-full bg-bbc-primary pt-1 text-center text-bbc-white">
                    {item.id}
                  </div>
                ) : (
                  <>
                    {" "}
                    {step < index + 1 ? (
                      <div className="h-8 w-8  rounded-full bg-bbc-primary pt-1 text-center text-bbc-white opacity-40">
                        {item.id}
                      </div>
                    ) : (
                      <BsFillCheckCircleFill className="text-3xl text-bbc-primary " />
                    )}
                  </>
                )}
                <div
                  className={`mt-2 text-center text-sm font-medium  ${
                    (step == 0 && index == 0) || step - 1 == index
                      ? "text-bbc-primary "
                      : "text-bbc-neutral-600"
                  } `}
                >
                  {item.name}
                </div>
              </div>
              <div
                className={`${
                  data?.length === index + 1 ? "hidden" : ""
                } col flex items-center`}
                style={{ height: "30px" }}
              >
                <div className=" h-0.5 w-full  bg-bbc-primary"></div>
              </div>
            </div>
          );
        })}
      </div>

      {/* mobile
       */}
      <div
        className={"mb-14 flex items-center justify-center lg:mb-20 lg:hidden"}
      >
        <div className="w-4">
          <div className="h-4 w-4 rounded-full border-4 border-bbc-primary bg-bbc-white"></div>
        </div>
        <div className="flex w-[calc(100%_-_32px)] items-center">
          {data?.map((item, index) => {
            return (
              <div key={index} style={{ width: `${width}%` }}>
                <div className={" w-full "}>
                  {(step == 0 && index == 0) || step - 1 == index ? (
                    <div className="h-2 w-full bg-bbc-primary " />
                  ) : (
                    <>
                      {step < index + 1 ? (
                        <div className="h-2 w-full bg-bbc-neutral-600  pt-1 text-center text-bbc-white " />
                      ) : (
                        <div className="h-2  w-full bg-bbc-primary  pt-1 text-center text-bbc-white " />
                      )}
                    </>
                  )}
                </div>
                {(step == 0 && index == 0) || step - 1 == index ? (
                  <div className="col-12 absolute left-0 right-0 mt-3 ml-auto  mr-auto text-center text-sm font-medium  text-bbc-primary">
                    {item.name}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
        <div className="w-4">
          <div className="h-4 w-4 rounded-full border-4 border-bbc-primary bg-bbc-primary"></div>
        </div>
      </div>

      {/* sub */}
      {data[step - 1]?.sub_step?.length > 1 && (
        <div className={"relative my-10 flex  items-center justify-center "}>
          {data[step - 1].sub_step?.map((item, index) => {
            return (
              <div key={index} className="flex w-[80px] items-center last:w-4">
                <div className={" "}>
                  {subStep - 1 === index ? (
                    <div className="h-4 w-4 rounded-full border-4 border-bbc-primary bg-bbc-white" />
                  ) : (
                    <div className="h-4 w-4 rounded-full border-4 border-bbc-primary bg-bbc-primary" />
                  )}
                </div>
                <div
                  className={`${
                    data?.length === index + 1 ? "hidden" : ""
                  } col flex items-center  `}
                >
                  <div className=" h-1 w-full bg-bbc-primary"></div>
                </div>
                {(subStep == 0 && index == 0) || subStep - 1 == index ? (
                  <div
                    className={`col-12 absolute left-0 right-0 mx-auto text-center font-medium  ${styles.subStepName} `}
                  >
                    {item.name}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default StepBar;
